import React, { Component } from 'react';
import propTypes from 'prop-types';

class CartPanel extends Component {
  render() {
    const { totalPrice, totalQuantity, currencyOptions } = this.props;

    return (
      <div className="sticky cart-panel">
        <div>
          Shopping Cart:{' '}
          <span className="itemsInCart">{totalQuantity || '0'}</span> items
        </div>
        <div>
          Total: {totalPrice.toLocaleString(undefined, currencyOptions) || '0'}
        </div>
      </div>
    );
  }
}

CartPanel.propTypes = {
  totalPrice: propTypes.number,
  totalQuantity: propTypes.number,
  currencyOptions: propTypes.object,
};

export default CartPanel;
